import { render } from "./BUTTON.vue?vue&type=template&id=d2602098"
import script from "./BUTTON.vue?vue&type=script&lang=js"
export * from "./BUTTON.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__